module.exports = __webpack_public_path__ + "img/avatar3.cb4a5c2a.png";